import { render, staticRenderFns } from "./user_address_page.vue?vue&type=template&id=2716540d&scoped=true"
import script from "./user_address_page.vue?vue&type=script&lang=js"
export * from "./user_address_page.vue?vue&type=script&lang=js"
import style0 from "./user_address_page.vue?vue&type=style&index=0&id=2716540d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716540d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2716540d')) {
      api.createRecord('2716540d', component.options)
    } else {
      api.reload('2716540d', component.options)
    }
    module.hot.accept("./user_address_page.vue?vue&type=template&id=2716540d&scoped=true", function () {
      api.rerender('2716540d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/user/user_address_page.vue"
export default component.exports